import { react2angular } from '@Shared.Angular/flowingly.helper/react2angular';
import { UserNotificationsMenuItem } from './UserNotificationsMenuItem';

export const UserNotificationsMenuItemBridge = react2angular(
  UserNotificationsMenuItem
);
